export default {
  create_sale_page: 'إنشاء صفحة البيع',
  sale_page_edited_by: 'عدل مؤخرا بواسطة {user_name} ( {user_role} )',
  sale_page_generated_by: 'تم إنشاؤها بواسطة {user_name} ( {user_role} )',
  sale_page_more_info: '<span style="color: var(--app-primary-color)">' + 'الأداء : ' + '<span style="color: var(--app-info-color)">الزيارات</span> {page_visits},&nbsp; ' + '<span style="color: var(--app-success-color)">الطلبات</span> {page_orders},&nbsp; ' + '<span style="color: var(--app-fire-color)">معدل التحويل</span> {conversion_rate} %</span>',
  sale_page_more_info_staff: 'من قبل {user_name} ( {user_role} ) ، الأداء: الزيارات {page_visits} ، الطلبات {page_orders} ، معدل التحويل {conversion_rate} ٪',
  here_you_will_see: 'هنا سترى جميع صفحات المبيعات التي تم إنشاؤها ، ويمكنك استخدامها كما هي أو تعديلها.',
  page_not_up_to_date_alert: 'هذه الصفحة ليست محدثة ، يرجى حفظها أو إلغاء التغييرات بالنقر على زر إلغاء التغييرات أعلاه.',
  last_updated_by: 'من قبل',
  buttons: {
    delete: 'حذف',
    edit: 'تعديل',
    preview: 'معاينة',
    duplicate: 'نسخ',
    create_by_ai: 'إنشاء بواسطة الذكاء الاصطناعي',
    generate_by_ai: {
      title: 'إضافة صفحة البيع بالذكاء الاصطناعي',
      tooltip: 'إستخدم Maxcom AI'
    }
  },
  dialogs: {
    delete: {
      title: 'حذف صفحة البيع',
      content: 'سيؤثر إيقاف صفحة البيع مؤقتًا أو حذفها على العناصر المرتبطة بها. هل انت متأكد انك تريد المتابعة ؟'
    }
  },
  filter: {
    search: {
      placeholder: 'تصفية العروض ...'
    },
    domain: {
      option_all: 'كل المتاجر'
    },
    offers: {
      option_all: 'كل العروض'
    },
    product: {
      option_all: 'كل الالمنتجات'
    },
    users: {
      option_all: 'جميع المستخدمين'
    },
    country: {
      option_all: 'جميع الدول'
    },
    offer_payment_type: {
      option_all: 'جميع خيارات الدفع'
    },
    sort_by: {
      text: 'ترتيب حسب',
      options: {
        date: 'التاريخ',
        new_to_old: 'من الجديد إلى القديم',
        old_to_new: 'من القديم إلى الجديد',
        visits: 'الزيارات',
        orders: 'الطلبات'
      }
    },
    sort: {
      new_to_old: 'من الجديد إلى القديم',
      old_to_new: 'من القديم إلى الجديد'
    }
  },
  sale_page_form: {
    toggle_form: 'انقر هنا لإنشاء صفحة البيع.',
    you_block_appear_here: 'ستظهر اجزاء صفحة البيع الخاصة بك هنا.',
    no_page_selected: 'لم يتم اختيار صفحة',
    no_offer_selected: 'لم يتم اختيار أي عرض',
    no_product_selected: 'لم يتم اختيار أي منتج...',
    sku: 'وحدة حفظ المخزون: {sku}',
    modes: {
      desktop: 'شاشة الكمبيوتر',
      mobile: 'شاشة الهاتف'
    },
    create_sale_page: {
      title: 'إنشاء صفحة بيع',
      subtitle: 'إنشاء صفحة بيع جديدة'
    },
    update_sale_page: {
      title: 'تعديل صفحة البيع',
      subtitle: 'تعديل صفحة البيع'
    },
    steps: {
      one: {
        title: 'الخطوة 1: معلومات المنتج'
      },
      two: {
        title: 'الخطوة 2: عناصر صفحة المبيعات',
        sub_title: 'يمكنك تعيين اللغة أو إضافة المزيد من معلومات المنتج، لمساعدتنا في إنشاء صفحة بيع أفضل تحتوي على جميع المعلومات المطلوبة حول المنتج (مثل حجم المنتج والألوان وحالات الاستخدام والبطارية والمواد وأي شيء يرغب عملاؤك في معرفته عن المنتج)'
      },
      three: {
        title: 'الخطوة 3: خيارات البيع',
        subtitle: 'تعديل اسم العروض والكمية والسعر'
      },
      four: {
        title: 'الخطوة 4: Upsells و Cross-sells',
        subtitle: 'upsells صفحة الشكر',
        subtitle_2: 'بعد ال Cross-sells: upsells من أجل عروض أخرى',
        note: {
          note: 'ملحوظة',
          description: 'سيتم تحيل قائمة عروض ال Cross-sell إذا كان عرض صفحة البيع محددا.'
        }
      },
      addons: {
        title: 'إضافات الصفحة'
      },
      blocks: {
        title: 'محتوى الصفحة'
      },
      tracking: {
        title: 'تتبع بالبكسل'
      }
    },
    fields: {
      status: {
        title: 'حالة الصفحة'
      },
      domain: {
        title: 'المتجر',
        placeholder: 'اختر متجرك'
      },
      offer: {
        title: 'عرض صفحة البيع',
        placeholder: 'حدد عرضك'
      },
      product: {
        title: 'منتج صفحة البيع',
        placeholder: 'إختر المنتج'
      },
      inventory_country: {
        title: 'بلد المخزون',
        placeholder: 'حدد البلد'
      },
      country: {
        title: 'البلد المستهدف',
        placeholder: 'لا بلد'
      },
      country_select_type: {
        title: 'تحديد بلد البيع',
        tooltip: 'أين يتواجد عملائك المستهدفين؟'
      },
      custom_currency: {
        display_currency: 'عملة البيع: {currency_code} ({currency_symbol})',
        edit_currency: 'تعديل العملة',
        title: 'العملة الإختيارية',
        placeholder: 'إختر عملة'
      },
      gender: {
        title: 'هذا المنتج من أجل'
      },
      custom_currency_symbol: {
        title: 'العملة المعروضة (لا تضع السعر هنا!)',
        placeholder: 'اختر رمز العملة'
      },
      shipping_countries: {
        title: 'دول الشحن',
        placeholder: 'إختر الدول التي تريد الشحن إليها'
      },
      default_currency: {
        title: 'العملة الافتراضية'
      },
      url_name: {
        title: 'عنوان url لصفحة البيع',
        placeholder: 'اكتب عنوان url لصفحة البيع'
      },
      page_title: {
        title: 'عنوان صفحة البيع',
        placeholder: 'اكتب عنوان صفحة البيع الخاصة بك'
      },
      description: {
        title: 'وصف صفحة البيع',
        placeholder: 'اكتب وصف صفحة البيع الخاصة بك'
      },
      language: {
        info: 'يمكنك تغيير اللغة من إعدادات المتجر أو تمكين لغات متعددة لتغييرها هنا.'
      },
      checkout_options: {
        pricing: {
          title: 'التسعير',
          clarification: 'أعد سعر البيع لقطعة واحدة، أو قطعتين، أو ثلاث قطع، أو عروض مجمعة مثل اشترِ قطعة واحدة واحصل على قطعة أخرى مجانًا...'
        },
        checkout_title: {
          title: 'عنوان الأستمارة'
        },
        checkout_form: {
          title: 'إستمارة الطلب',
          custom_field_name: 'إسم الحقل الخاص',
          fields: {
            custom_fields: {
              title: 'الحقول',
              buttons: {
                reset: 'إعادة ضبط'
              }
            },
            rating: {
              count: 'عدد التقييمات'
            }
          }
        },
        shipping: {
          title: 'شحن'
        },
        reviews: {
          title: 'المراجعات'
        }
      },
      product_video: {
        title: '(إختياري) فيديو المنتج',
        placeholder: 'مثال: https://youtube.com?v=xxxx'
      },
      title: {
        title: 'عنوان الإستمارة',
        placeholder: 'عنوان إستمارتك'
      },
      subTitle: {
        title: 'العنوان الإستمارة الثانوي',
        placeholder: 'عنوان إستمارتك الثانوي'
      },
      checkout_length: {
        title: 'طول استمارة المعلومات'
      },
      add_block: {
        title: 'إضافة محتوى جديد',
        button_title: 'أضف إلى الصفحة'
      },
      short_product: {
        title: 'اسم المنتج القصير',
        placeholder: 'اكتب اسم المنتج القصير الخاص بك'
      },
      custom_data: {
        shipping: {
          delivery_text: {
            title: 'نص التوصيل',
            placeholder: 'توصيل مجاني',
            default: 'موعد التوصيل'
          },
          delivery_time: {
            title: 'موعد التوصيل'
          }
        },
        reviews: {
          reviews_rating: {
            title: 'تصنيف المراجعات'
          },
          reviews_count: {
            title: 'عدد المراجعات',
            placeholder: 'حدد عدد المراجعات'
          },
          reviews_text: '{rating} ({count} مراجعة)'
        }
      }
    },
    default_values: {
      options: {
        option_1: {
          option_name: 'خيار 1',
          offer_name: '{product_name} 1x شراء',
          discount: '{{up}}/الوحدة - {{dis}} تخفيض'
        },
        option_2: {
          option_name: 'خيار 2',
          offer_name: 'أشتري 2 أحصل 1 مجان',
          discount: '{{up}}/الوحدة - {{dis}} تخفيض'
        },
        option_3: {
          option_name: 'خيار 3',
          offer_name: 'أشتري 3 أحصل 2 مجان',
          discount: '{{up}}/الوحدة - {{dis}} تخفيض'
        },
        option_4: {
          option_name: 'خيار 4',
          offer_name: '2 أشتري',
          discount: '{{up}}/الوحدة - {{dis}} تخفيض'
        },
        option_5: {
          option_name: 'خيار 5',
          offer_name: '3 أشتري',
          discount: '{{up}}/الوحدة - {{dis}} تخفيض'
        }
      },
      upsells: {
        upsell_1: {
          option_name: 'Options {n}',
          offer_name: 'Offer name',
          discount: 'Discount and unit price'
        }
      },
      cross_sells: {
        cross_sell_1: {
          option_name: 'Options {n}',
          offer_name: 'Offer name',
          discount: 'Discount and unit price'
        }
      }
    },
    option_fields: {
      option_name: {
        title: 'خيارات',
        translation: {
          option_1: 'الخيار 1',
          option_2: 'الخيار 2',
          option_3: 'الخيار 3',
          option_4: 'الخيار 4',
          option_5: 'الخيار 5'
        }
      },
      offer_name_and_discount: {
        title: 'اسم العرض / نص الخصم',
        placeholder: 'اكتب اسم العرض والخصم الخاص بك'
      },
      normal_and_sale_price: {
        title: 'سعر البيع / السعر القديم'
      },
      offer_name: {
        title: 'اسم العرض',
        placeholder: 'اكتب عرضك'
      },
      discount: {
        title: 'الخصم وسعر الوحدة',
        placeholder: 'اكتب الخصم و / أو سعر الوحدة'
      },
      quantity: {
        title: 'كمية'
      },
      normal_price: {
        title: 'السعر العادي'
      },
      sale_price: {
        title: 'سعر البيع'
      }
    },
    upsell_fields: {
      option_name: {
        title: 'خيار'
      },
      offer_name: {
        title: 'اسم العرض',
        placeholder: 'اكتب اسم العرض الخاص بك'
      },
      offer_nick_name: {
        title: 'لقب العرض',
        placeholder: 'اكتب لقب العرض الخاص بك'
      },
      offer_type: {
        title: 'نوع العرض',
        placeholder: 'حدد نوع العرض الخاص بك'
      },
      discount: {
        title: 'الخصم وسعر الوحدة',
        placeholder: 'اكتب الخصم و / أو سعر الوحدة'
      },
      quantity: {
        title: 'كمية'
      },
      normal_price: {
        title: 'السعر العادي'
      },
      sale_price: {
        title: 'سعر البيع'
      }
    },
    cross_sell_fields: {
      option_name: {
        title: 'خيار'
      },
      offer_name: {
        title: 'اسم العرض',
        placeholder: 'اختر عرضا'
      },
      offer_type: {
        title: 'نوع العرض',
        placeholder: 'حدد نوع العرض الخاص بك'
      },
      offer_nick_name: {
        title: 'لقب العرض',
        placeholder: 'اكتب لقب العرض الخاص بك'
      },
      discount: {
        title: 'الخصم وسعر الوحدة',
        placeholder: 'اكتب الخصم و / أو سعر الوحدة'
      },
      quantity: {
        title: 'كمية'
      },
      normal_price: {
        title: 'السعر العادي'
      },
      sale_price: {
        title: 'سعر البيع'
      }
    },
    addon_fields: {
      background_color: {
        title: 'لون الخلفية'
      },
      theme: {
        is_enabled: 'إختر ألوان بديلة لالصفحة',
        primary_color: {
          title: 'اللون الرئيسي'
        },
        secondary_color: {
          title: 'اللون الثانوي'
        }
      },
      show_sale_page_navbar: {
        title: 'إظهار القائمة navbar.'
      },
      show_sale_page_footer: {
        title: 'إظهار القائمة footer.'
      },
      sticky_buy_button: {
        title: 'إظهار زر الشراء اللاصق.'
      },
      visible_button_price: {
        title: 'إظهار الثمن مع زر الشراء اللاصق.'
      },
      trust_badges_visibility: {
        title: 'شارات الثقة عند ما بعد الدفع.'
      },
      about_us_visibility: {
        title: 'معلومات عنا عند ما بعد الدفع.'
      },
      after_sale_faq_visibility: {
        title: '.الأسئلة المتداولة عند ما بعد الدفع'
      },
      disable_selection_and_context_menu: {
        title: 'تعطيل تحديد النص والنقر بزر الماوس الأيمن.'
      },
      include_in_home_and_product_page: {
        title: 'عرض المنتج على الصفحة الرئيسية وصفحة المنتجات.'
      },
      whatsapp_button: {
        title: 'إظهار زر الواتساب',
        country_id: {
          placeholder: 'كود الهاتف'
        },
        phone_number: {
          title: 'رقم الهاتف'
        }
      },
      whatsapp_phone_number: {
        title: '.رقم هاتف الواتساب'
      }
    },
    tracking: {
      buttons: {
        add_pixel: 'إضافة بكسل'
      }
    },
    buttons: {
      plan_incentives: '{tries} صفحات تم إنشاؤها باستخدام الذكاء الاصطناعي!',
      plan_incentives_tries_left: '{tries} متبقية',
      plan_incentives_button: 'قم بالترقية الآن',
      create: 'إنشاء صفحة بيع',
      delete: 'حذف الصفحة',
      save: 'حفظ الصفحة',
      preview: 'معاينة الصفحة',
      duplicate: 'نسخ الصفحة',
      cancel: 'الغاء',
      add_block: 'إضافة جزء جديد',
      reset_form: 'إلغاء التغييرات',
      add_pixel: 'أضافة بكسل'
    }
  }
};